export type PromoValues = {
  firstYearPrice: number;
  regularAnnualPrice: number;
  savings: number;
  renewPrice: number;
};

/**
 * Compute first-year promo values for the annual-billing upgrade card when
 * upgrading from Free. Assumes the coupon = two months free at the monthly
 * rate on annual billing (duration: 'once').
 */
export const calcPromoValues = (annualAmount: number, monthlyAmount: number): PromoValues => {
  const savings = monthlyAmount * 2;
  return {
    firstYearPrice: annualAmount - savings,
    regularAnnualPrice: annualAmount,
    savings,
    renewPrice: annualAmount,
  };
};
